import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../api';
import { etagAtual } from '../../data/mundoSync';

const CHAVE = 'uoidle.loja.vistas';

function vistasGravadas(): Set<string> {
  try {
    const raw = localStorage.getItem(CHAVE);
    if (!raw) return new Set();
    const lista = JSON.parse(raw) as unknown;
    if (!Array.isArray(lista)) return new Set();
    return new Set(lista.filter((s): s is string => typeof s === 'string'));
  } catch {
    return new Set();
  }
}

/** Selo NOVO: some ao abrir a Loja e volta quando entra uma oferta nova. */
export function useNovidadeLoja(mundoVersao: number | undefined) {
  const [novidade, setNovidade] = useState(false);
  const skusRef = useRef<readonly string[]>([]);

  useEffect(() => {
    let vivo = true;
    void api.loja(etagAtual() || '0').then(vitrine => {
      if (!vivo) return;
      const skus = vitrine.aberta
        ? vitrine.abas.flatMap(aba => aba.ofertas.filter(o => o.naJanela).map(o => o.sku))
        : [];
      skusRef.current = skus;
      const vistas = vistasGravadas();
      setNovidade(skus.some(s => !vistas.has(s)));
    }).catch(() => { /* sem vitrine, sem selo */ });
    return () => { vivo = false; };
  }, [mundoVersao]);

  const marcarLojaVista = useCallback(() => {
    try { localStorage.setItem(CHAVE, JSON.stringify(skusRef.current)); } catch { /* sem storage */ }
    setNovidade(false);
  }, []);

  return { novidade, marcarLojaVista };
}
